<template>
  <twitch-stream-list @subtitleUpdate='subtitleUpdate' @errorUpdate='errorUpdate' />
</template>

<script>
import TwitchStreamList from '@/components/TwitchStreamList'

export default {
  name: 'home',
  components: {
    TwitchStreamList
  },
  methods: {
    subtitleUpdate: function(s) {
      this.$emit('subtitleUpdate', s)
    },
    errorUpdate: function(e) {
      this.$emit('errorUpdate', e)
    },
  },
}
</script>